import { ThemeProvider } from '@mui/material';
import { FC } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import { AppRouter } from '../AppRouter';
import { Layout } from '../main/Layout';
import { store } from '../store/store';
import { theme } from '../theme';

import AuthProvider from './AuthProvider/AuthProvider';
import DataProvider from './DataProvider';
import HeadProvider from './HeadProvider/HeadProvider';
import ReduxToastr from './ReduxToastr';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const MainProvider: FC = () => {
  return (
    <HeadProvider>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <ReduxToastr />
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              <AuthProvider>
                <DataProvider>
                  <Layout>
                    <AppRouter />
                  </Layout>
                </DataProvider>
              </AuthProvider>
            </BrowserRouter>
          </ThemeProvider>
        </QueryClientProvider>
      </Provider>
    </HeadProvider>
  );
};

export default MainProvider;
